// extracted by mini-css-extract-plugin
export default {"StickyBlock":"beo_a bho_bj"};